import { CAREERS_PATH, DESIGN_STUDIO_PATH, STUDIO_PATH } from '@/consts/routes';

/** Desktop Studio mega-menu — image cards with labels and links. */
export const STUDIO_NAV_MEGA_MENU = {
  items: [
    {
      itemKey: 'our-studio',
      label: 'Our Studio',
      href: STUDIO_PATH,
      image: {
        src: '/imgs/nav/studio/our-studio.webp',
        alt: 'Kitchen showroom with dark cabinets and wood accents',
      },
    },
    {
      itemKey: 'design-studio',
      label: 'Join our Design Team',
      href: DESIGN_STUDIO_PATH,
      image: {
        src: '/imgs/nav/studio/design-studio.jpg',
        alt: 'Graphic designer working on color selection and drawing',
      },
    },
    {
      itemKey: 'careers',
      label: 'Careers',
      href: CAREERS_PATH,
      image: {
        src: '/imgs/nav/studio/careers.webp',
        alt: 'NIICO craftsmanship and millwork production',
      },
    },
  ],
};

/** Flat links for mobile drawer under Studio. */
export const STUDIO_NAV_DRAWER_LINKS = STUDIO_NAV_MEGA_MENU.items.map(({ label, href }) => ({
  label,
  href,
}));

export function getStudioNavHrefs() {
  return STUDIO_NAV_MEGA_MENU.items.map(item => item.href);
}
